var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrgChartIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "States=Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2127"
  }, /*#__PURE__*/React.createElement("path", {
    id: "family_history",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8466 10.5384L12.8466 12L15.6159 12C15.9966 12 16.3226 12.1356 16.5937 12.4067C16.8649 12.6779 17.0005 13.0038 17.0005 13.3846L17.0005 14.3077L18.3851 14.3077C18.5812 14.3077 18.7457 14.374 18.8784 14.5067C19.011 14.6394 19.0774 14.8038 19.0774 15L19.0774 19.1538C19.0774 19.35 19.011 19.5144 18.8784 19.6471C18.7457 19.7798 18.5812 19.8461 18.3851 19.8461L14.2312 19.8461C14.0351 19.8461 13.8707 19.7798 13.738 19.6471C13.6053 19.5144 13.5389 19.35 13.5389 19.1538L13.5389 15C13.5389 14.8038 13.6053 14.6394 13.738 14.5067C13.8707 14.374 14.0351 14.3077 14.2312 14.3077L15.6159 14.3077L15.6159 13.3846L8.46201 13.3846L8.46201 14.3846L7.07739 14.3846L7.07739 13.3846C7.07739 13.0038 7.21297 12.6779 7.48412 12.4067C7.75528 12.1356 8.08124 12 8.46201 12L11.462 12L11.462 10.5384L12.8466 10.5384ZM14.9235 15.6923L17.6928 15.6923L17.6928 18.4615L14.9235 18.4615L14.9235 15.6923Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 684",
    x: 14,
    y: 15,
    width: 4,
    height: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "family_history_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46152 14.3077L9.84613 14.3077C10.0423 14.3077 10.2067 14.374 10.3394 14.5067C10.4721 14.6394 10.5384 14.8038 10.5384 15L10.5384 19.1538C10.5384 19.35 10.4721 19.5144 10.3394 19.6471C10.2067 19.7798 10.0423 19.8461 9.84613 19.8461L5.69229 19.8461C5.49613 19.8461 5.33171 19.7798 5.19902 19.6471C5.06632 19.5144 4.99998 19.35 4.99998 19.1538L4.99998 15C4.99998 14.8038 5.06632 14.6394 5.19902 14.5067C5.33171 14.374 5.49613 14.3077 5.69229 14.3077L7.0769 14.3077L8.46152 14.3077ZM6.38459 15.6923L9.15382 15.6923L9.15382 18.4615L6.38459 18.4615L6.38459 15.6923Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 683",
    x: 6,
    y: 15,
    width: 4,
    height: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "family_history_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.731 4.99999L14.1156 4.99999C14.3118 4.99999 14.4762 5.06634 14.6089 5.19903C14.7416 5.33172 14.8079 5.49614 14.8079 5.6923L14.8079 9.84614C14.8079 10.0423 14.7416 10.2067 14.6089 10.3394C14.4762 10.4721 14.3118 10.5385 14.1156 10.5385L9.96177 10.5385C9.76561 10.5385 9.60119 10.4721 9.4685 10.3394C9.33581 10.2067 9.26946 10.0423 9.26946 9.84614L9.26946 5.6923C9.26946 5.49614 9.33581 5.33172 9.4685 5.19903C9.60119 5.06634 9.76561 4.99999 9.96177 4.99999L11.3464 4.99999L12.731 4.99999ZM10.6541 6.38461L13.4233 6.38461L13.4233 9.15384L10.6541 9.15384L10.6541 6.38461Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 683_2",
    x: 10,
    y: 6,
    width: 4,
    height: 4,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgChartIcon);
export default __webpack_public_path__ + "static/media/orgChartIcon.3dca8814b735929db5b8a850b9a5f4f9.svg";
export { ForwardRef as ReactComponent };